import { render, staticRenderFns } from "./ListSubmission.vue?vue&type=template&id=2e30f430&"
import script from "./ListSubmission.vue?vue&type=script&lang=js&"
export * from "./ListSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports